import axios from "axios";

const baseUrl = "https://apireservadesalas.com.br/api"

const api = axios.create({
	baseURL: baseUrl,
});

export default api;
